import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapDeleteConfirmationComponent } from '../map-delete-confirmation/map-delete-confirmation.component';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { SubscriptionStatus } from '../../../models/subscription-usage.model';
import { DowngradeStatusResponse } from '../../models/downgrade-response.model';

@Component({
    selector: 'app-account-cleanup-wizard',
    templateUrl: './account-cleanup-wizard.component.html',
    styleUrls: ['./account-cleanup-wizard.component.scss'],
    standalone: false
})
export class AccountCleanupWizardComponent implements OnInit {
  userId: any;
  upgradePlan: any;
  currentPlan: any;
  planUsage: SubscriptionStatus;
  downgradeResponse!: DowngradeStatusResponse;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal,private currentUserService: CurrentUserService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setupCurrentUserPlanUsage();
  }

  setupCurrentUserPlanUsage() {
    this.currentUserService.planUsageData.subscribe((data: SubscriptionStatus) => {
      if (data) {
        this.planUsage = data;
        this.cdr.detectChanges();
      }
    });
  }

  get oldTierName(): string {
    return this.downgradeResponse?.from_plan?.name || this.currentPlan?.plan_name || 'Current Plan';
  }

  get newTierName(): string {
    return this.downgradeResponse?.to_plan?.name || this.upgradePlan?.name || 'New Plan';
  }

  get maxMaps(): number {
    return this.downgradeResponse?.limits_comparison?.maps?.new_plan_limit ?? (this.upgradePlan?.features?.maps_uploaded || 0);
  }

  get maxGames(): number {
    return this.downgradeResponse?.limits_comparison?.games?.new_plan_limit ?? (this.upgradePlan?.features?.max_games_created || 0);
  }

  get maxCharacters(): number {
    return this.downgradeResponse?.limits_comparison?.characters?.new_plan_limit ?? (this.upgradePlan?.features?.max_active_characters || 0);
  }

  // Actual usage count from limits_comparison
  get currentMaps(): number {
    return this.downgradeResponse?.limits_comparison?.maps?.current_usage ?? (this.planUsage?.usage?.maps_uploaded || 0);
  }

  get currentGames(): number {
    return this.downgradeResponse?.limits_comparison?.games?.current_usage ?? (this.planUsage?.usage?.games_created || 0);
  }

  get currentCharacters(): number {
    return this.downgradeResponse?.limits_comparison?.characters?.current_usage ?? (this.planUsage?.usage?.characters_created || 0);
  }

  isMapsOverLimit(): boolean {
    if (this.maxMaps === -1) return false;
    return this.currentMaps > this.maxMaps;
  }

  isGamesOverLimit(): boolean {
    if (this.maxGames === -1) return false;
    return this.currentGames > this.maxGames;
  }

  isCharactersOverLimit(): boolean {
    if (this.maxCharacters === -1) return false;
    return this.currentCharacters > this.maxCharacters;
  }

  close() {
    this.activeModal.dismiss();
  }

  proceed() {
    this.activeModal.close('proceed');
    const modalRef = this.modalService.open(MapDeleteConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    });
    modalRef.componentInstance.userId = this.userId;
    modalRef.componentInstance.upgradePlan = this.upgradePlan;
    modalRef.componentInstance.currentPlan = this.currentPlan;
    modalRef.componentInstance.downgradeResponse = this.downgradeResponse;
    modalRef.result.then((result) => {
      // Continuing the chain
    
          this.cdr.detectChanges();});
  }
}
